"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _exchangeSearchCommon = require("@mulesoft/exchange-search-common");
var adapterUtils = _interopRequireWildcard(require("@mulesoft/exchange-search-common/lib/utils"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); } /*
  eslint
    no-underscore-dangle: 0
*/
var ANGAssetHighlightAdapter = exports.default = /*#__PURE__*/function (_GenericANGAssetHighl) {
  function ANGAssetHighlightAdapter() {
    (0, _classCallCheck2.default)(this, ANGAssetHighlightAdapter);
    return _callSuper(this, ANGAssetHighlightAdapter, arguments);
  }
  (0, _inherits2.default)(ANGAssetHighlightAdapter, _GenericANGAssetHighl);
  return (0, _createClass2.default)(ANGAssetHighlightAdapter, [{
    key: "_getWebAPINode",
    value: function _getWebAPINode() {
      return adapterUtils.getANGHighlight(this.latestHighlight, 'webapi-spec', 'WebAPI');
    }
  }, {
    key: "_getWebAPIServerNode",
    value: function _getWebAPIServerNode() {
      return adapterUtils.getANGHighlight(this.latestHighlight, 'webapi-spec', 'Server');
    }
  }, {
    key: "_getWebAPIAbstractDeclarationNode",
    value: function _getWebAPIAbstractDeclarationNode() {
      return adapterUtils.getANGHighlight(this.latestHighlight, 'webapi-spec', 'AbstractDeclaration');
    }
  }, {
    key: "_getWebAPIEndpointNode",
    value: function _getWebAPIEndpointNode() {
      return adapterUtils.getANGHighlight(this.latestHighlight, 'webapi-spec', 'EndPoint');
    }
  }, {
    key: "_getWebAPIExampleNode",
    value: function _getWebAPIExampleNode() {
      return adapterUtils.getANGHighlight(this.latestHighlight, 'webapi-spec', 'Example');
    }
  }, {
    key: "_getWebAPIShapeNode",
    value: function _getWebAPIShapeNode() {
      return adapterUtils.getANGHighlight(this.latestHighlight, 'webapi-spec', 'Shape');
    }
  }, {
    key: "_getWebAPIOperationNode",
    value: function _getWebAPIOperationNode() {
      return adapterUtils.getANGHighlight(this.latestHighlight, 'webapi-spec', 'Operation');
    }
  }, {
    key: "_getWebAPIParameterNode",
    value: function _getWebAPIParameterNode() {
      return adapterUtils.getANGHighlight(this.latestHighlight, 'webapi-spec', 'Parameter');
    }
  }, {
    key: "webAPI",
    get: function get() {
      var apiNode = this._getWebAPINode();
      return {
        name: adapterUtils.getProp(apiNode, 'name'),
        description: adapterUtils.getProp(apiNode, 'description')
      };
    }
  }, {
    key: "abstractDeclarations",
    get: function get() {
      var abstractDeclarationNode = this._getWebAPIAbstractDeclarationNode();
      if (!abstractDeclarationNode) {
        return {
          names: [],
          descriptions: []
        };
      }
      return {
        names: abstractDeclarationNode.name || [],
        descriptions: abstractDeclarationNode.description || []
      };
    }
  }, {
    key: "examples",
    get: function get() {
      var exampleNode = this._getWebAPIExampleNode();
      if (!exampleNode) {
        return {
          displayNames: [],
          names: [],
          descriptions: []
        };
      }
      return {
        displayNames: exampleNode.displayName || [],
        names: exampleNode.name || [],
        descriptions: exampleNode.description || []
      };
    }
  }, {
    key: "shapes",
    get: function get() {
      var shapeNode = this._getWebAPIShapeNode();
      if (!shapeNode) {
        return {
          displayNames: [],
          names: [],
          descriptions: []
        };
      }
      return {
        displayNames: shapeNode.displayName || [],
        names: shapeNode.name || [],
        descriptions: shapeNode.description || []
      };
    }
  }, {
    key: "server",
    get: function get() {
      var serverNode = this._getWebAPIServerNode();
      return {
        urlTemplate: adapterUtils.getProp(serverNode, 'urlTemplate')
      };
    }
  }, {
    key: "endpoints",
    get: function get() {
      var endpointNode = this._getWebAPIEndpointNode();
      if (!endpointNode) {
        return {
          paths: [],
          names: [],
          summary: [],
          descriptions: []
        };
      }
      return {
        paths: endpointNode.path || [],
        names: endpointNode.name || [],
        summaries: endpointNode.summary || [],
        descriptions: endpointNode.description || []
      };
    }
  }, {
    key: "operations",
    get: function get() {
      var operationNode = this._getWebAPIOperationNode();
      if (!operationNode) {
        return {
          descriptions: []
        };
      }
      return {
        descriptions: operationNode.description || []
      };
    }
  }, {
    key: "parameters",
    get: function get() {
      var parameterNode = this._getWebAPIParameterNode();
      if (!parameterNode) {
        return {
          names: [],
          descriptions: []
        };
      }
      return {
        names: parameterNode.name || [],
        descriptions: parameterNode.description || []
      };
    }
  }, {
    key: "specificationLength",
    get: function get() {
      var props = [this.webAPI, this.abstractDeclarations, this.examples, this.shapes, this.server, this.endpoints, this.operations, this.parameters];
      return props.reduce(function (acum, current) {
        var total = Object.keys(current).reduce(function (totalAcum, key) {
          if (Array.isArray(current[key])) {
            return totalAcum + current[key].length;
          }
          return totalAcum + current[key] ? 1 : 0;
        }, 0);
        return acum + total;
      }, 0);
    }
  }]);
}(_exchangeSearchCommon.ANGAssetHighlightAdapter);
//# sourceMappingURL=ANGAssetHighlightAdapter.js.map